import { io } from "socket.io-client";

let socket;

export const initSocket = () => {
  if (!socket) {
    socket = io(process.env.REACT_APP_SERVER_BETABIT_BASE_API);
  }
  return socket;
};

export const getSocket = () => socket;
